import axios from '@/utils/axios'
import * as types from '../mutation-types'
import { dispatchToSubscribers, loadingPromise } from "../../utils/store";
import { isLatestRequestActual } from "../../utils/request";

let campaign_monitor_interests_last_fetch = null;
let mailchimp_interests_last_fetch = null;
let plans_last_fetch = null;
let lastResource = null;
let countries_last_fetch = null;

// state
export const state = {
  mailchimp_interests: [],
  mailchimp_interests_loading: false,
  campaign_monitor_interests: [],
  campaign_monitor_interests_loading: false,
  plans: [],
  plans_loading: false,
  countries: [],
  countries_loading: false,
};

// getters
export const getters = {
  mailchimp_interests: state => state.mailchimp_interests,
  campaign_monitor_interests: state => state.campaign_monitor_interests,
  plans: state => state.plans,
  countries: state => state.countries
};

// mutations
export const mutations = {

  [types.SET_MAILCHIMP_INTERESTS](state, interests) {
    state.mailchimp_interests = interests;
  },

  [types.SET_MAILCHIMP_INTERESTS_LOADING](state, isLoading) {
    state.mailchimp_interests_loading = isLoading;
  },

  [types.SET_CAMPAIGN_MONITOR_INTERESTS](state, interests) {
    state.campaign_monitor_interests = interests;
  },

  [types.SET_CAMPAIGN_MONITOR_INTERESTS_LOADING](state, isLoading) {
    state.campaign_monitor_interests_loading = isLoading;
    dispatchToSubscribers(types.SET_CAMPAIGN_MONITOR_INTERESTS_LOADING, isLoading);
  },

  [types.SET_PLANS](state, plans) {
    state.plans = plans;
  },

  [types.SET_PLANS_LOADING](state, isLoading) {
    state.plans_loading = isLoading;
    dispatchToSubscribers(types.SET_PLANS_LOADING, isLoading);
  },
  [types.SET_COUNTRIES](state, countries) {
    state.countries = countries;
  },
  [types.SET_COUNTRIES_LOADING](state, isLoading) {
    state.countries_loading = isLoading;
    dispatchToSubscribers(types.SET_COUNTRIES_LOADING, isLoading);
  },

};

// actions
export const actions = {

  async fetchMailchimpInterests({commit}) {
    try {
      if (state.mailchimp_interests_loading) {
        await loadingPromise(types.SET_MAILCHIMP_INTERESTS_LOADING);
      }

      if (mailchimp_interests_last_fetch && isLatestRequestActual(mailchimp_interests_last_fetch)) {
        return state.mailchimp_interests;
      }

      commit(types.SET_MAILCHIMP_INTERESTS_LOADING, true);

      const {data: {groups}} = await axios.get('/admin/integrations/mailchimp/categories');

      commit(types.SET_MAILCHIMP_INTERESTS, groups);
      mailchimp_interests_last_fetch = new Date();

      return groups;
    } catch (e) {
      commit(types.SET_MAILCHIMP_INTERESTS, null);
      throw (e);
    } finally {
      commit(types.SET_MAILCHIMP_INTERESTS_LOADING, false);
    }
  },

  async fetchCampaignMonitorInterests({commit, state}) {
    try {
      if (state.campaign_monitor_interests_loading) {
        await loadingPromise(types.SET_CAMPAIGN_MONITOR_INTERESTS_LOADING);
      }

      commit(types.SET_CAMPAIGN_MONITOR_INTERESTS_LOADING, true);

      if (campaign_monitor_interests_last_fetch && isLatestRequestActual(campaign_monitor_interests_last_fetch)) {
        return state.campaign_monitor_interests;
      }

      const {data: {items}} = await axios.get('/admin/integrations/campaignmonitor/admin-lists');

      commit(types.SET_CAMPAIGN_MONITOR_INTERESTS, items);
      campaign_monitor_interests_last_fetch = new Date();

      return items;
    } catch (e) {
      commit(types.SET_CAMPAIGN_MONITOR_INTERESTS, []);
      throw (e);
    } finally {
      commit(types.SET_CAMPAIGN_MONITOR_INTERESTS_LOADING, false);
    }
  },

  async fetchPlans({commit, state}) {
    try {
      if (state.plans_loading) {
        await loadingPromise(types.SET_PLANS);
      }

      commit(types.SET_PLANS_LOADING, true);

      if (plans_last_fetch && isLatestRequestActual(plans_last_fetch) && lastResource === this.getters['resource/currentResource'].key) {
        return state.plans;
      }

      const { data: { items } } = await axios.get('/admin/plans', { params: { limit: 100 } });

      commit(types.SET_PLANS, items);
      plans_last_fetch = new Date();
      lastResource = this.getters['resource/currentResource'].key;

      return items;
    } catch (e) {
      commit(types.SET_PLANS, []);
      throw (e);
    } finally {
      commit(types.SET_PLANS_LOADING, false);
    }
  },

  async fetchCountries({ commit, state }) {
    try {
      if (state.countries_loading) {
        await loadingPromise(types.SET_COUNTRIES_LOADING);
      }

      commit(types.SET_COUNTRIES_LOADING, true);

      if (countries_last_fetch && isLatestRequestActual(countries_last_fetch) && lastResource === this.getters['resource/currentResource'].key) {
        return state.countries;
      }

      const { data: { items } } = await axios.get('/admin/countries', { params: { limit: 100 } });

      commit(types.SET_COUNTRIES, items);
      countries_last_fetch = new Date();
      lastResource = this.getters['resource/currentResource'].key;

      return items;
    } catch (e) {
      commit(types.SET_COUNTRIES, []);
      throw e;
    } finally {
      commit(types.SET_COUNTRIES_LOADING, false);
    }
  },

};
